import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import PasswordMeter from './PasswordMeter';

const styles = () => ({
  appBar: {
    color: '#fff',
    backgroundColor: '#2096f3',
    boxShadow: 'none',
    borderBottom: '1px solid #eee',
    position: 'relative',
  },
  contentWrapper: {
    maxWidth: 720,
    margin: '0 auto',
  },
  textField: {
    marginLeft: 8,
    marginRight: 8,
    width: '100%',
  },
  saveButton: {
    marginTop: 40,
    width: '100%',
    padding: '16px 32px',
    backgroundColor: '#f56a12',
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
  formHelperText: {
    margin: '16px 8px 0',
  },
  passwordMeterWrapper: {
    margin: '0 8px',
  },
});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

class MenuSettingsDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: props.isOpen,
      hash: '', // HACK
      currentPassword: '',
      newPassword: '',
      repeatPassword: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
  }

  componentDidUpdate() {
    if (this.props.hash === this.state.hash) {
      return;
    }

    this.setState({
      isOpen: this.props.isOpen,
      hash: this.props.hash,
    });
  }

  handleChange(event) {
    const key = event.target.name;
    const value = event.target.value;

    this.setState({
      [key]: value,
    });
  }

  handleClose() {
    this.setState({
      isOpen: false,
    });
  }

  handleSaveClick() {
    const {
      enqueueSnackbar,
      t,
    } = this.props;

    axios
      .post(`${window.apiUrl}/password`, qs.stringify({
        current: this.state.currentPassword,
        new: this.state.newPassword,
        repeat: this.state.repeatPassword,
      }))
      .then((response) => {
        if (response.data.success) {
          enqueueSnackbar(t('You have successfully changed your password.'), {
            variant: 'success',
            autoHideDuration: 2000,
          });
          this.setState({
            currentPassword: '',
            newPassword: '',
            repeatPassword: '',
          });
        } else {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        }
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      classes,
      t,
    } = this.props;
    const {
      isOpen,
      currentPassword,
      newPassword,
      repeatPassword,
    } = this.state;

    return (
      <Dialog
        fullScreen
        open={isOpen}
        onClose={this.handleClose}
        TransitionComponent={Transition}
        className="menu-password-dialog"
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              color="inherit"
              onClick={this.handleClose}
              aria-label={t('Close')}
              className="menu-password-dialog-close-button"
            >
              <CloseIcon />
            </IconButton>
            <Typography
              variant="h6"
              color="inherit"
            >
              {t('Change password')}
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent className={classes.contentWrapper}>
          <TextField
            id="current"
            label={t('Current password')}
            className={classes.textField}
            margin="normal"
            type="password"
            value={currentPassword}
            name="currentPassword"
            onChange={this.handleChange}
          />
          <TextField
            id="new"
            label={t('New password')}
            className={classes.textField}
            margin="normal"
            type="password"
            value={newPassword}
            name="newPassword"
            onChange={this.handleChange}
          />
          <div className={classes.passwordMeterWrapper}>
            <PasswordMeter password={newPassword} useSuspense={false} />
          </div>
          <TextField
            id="repeat"
            label={t('Repeat password')}
            className={classes.textField}
            margin="normal"
            type="password"
            value={repeatPassword}
            name="repeatPassword"
            onChange={this.handleChange}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleSaveClick}
            className={`menu-password-dialog-save-button ${classes.saveButton}`}
          >
            {t('Save')}
          </Button>
        </DialogContent>
      </Dialog>
    );
  }
}

export default withStyles(styles)(withSnackbar(withTranslation()(MenuSettingsDialog)));
